import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApplicantScheduleResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CalendarioTurnosService {
  constructor(private http: HttpClient) {}

  getCalendarShifts(trainingId: string): Observable<ApplicantScheduleResponse> {
    return this.http.get<ApplicantScheduleResponse>(
      `${environment.apiurl}/api/v1.0/schedule-info/${trainingId}`
    );
  }
}
